import React from 'react'
import { useRouter } from 'next/router'

type HighlightTextProps = {
  text: string
  className?: string
}

/**
 * Composant pour surligner les termes de recherche dans un texte
 * Utilise le paramètre de recherche de l'URL (q ou search)
 */
const HighlightText: React.FC<HighlightTextProps> = ({ text, className }) => {
  const router = useRouter()
  const searchQuery = router.query.q || router.query.search || router.query.query

  if (!text) return null

  if (!searchQuery) {
    return <span className={className}>{text}</span>
  }

  const query = decodeURI(String(searchQuery)).toLowerCase()
  const searchTerms = query.split(/\s+/).filter(term => term.length >= 2)

  if (searchTerms.length === 0) {
    return <span className={className}>{text}</span>
  }

  // Créer une regex pour tous les termes de recherche
  const escapedTerms = searchTerms.map(term => 
    term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  )
  const regex = new RegExp(`(${escapedTerms.join('|')})`, 'gi')

  const parts = text.split(regex)

  return (
    <span className={className}>
      {parts.map((part, index) => {
        const isMatch = searchTerms.some(
          term => part.toLowerCase() === term.toLowerCase()
        )
        return isMatch ? (
          <mark key={index}>{part}</mark>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      })}
    </span>
  )
}

export default HighlightText
